import type { UrlParams } from '../api/models/types'

//*TODO: Decide whether this should either:
//* 1. Return a Record<string, string> including ALL url params, including those that are not in the UrlParams type, OR:
//* 2. Return a UrlParams object, in which case we should only include the params that are in the UrlParams type.
export default function getUrlDict(): UrlParams {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  const dict: Record<string, string> = {}

  for (const [key, value] of params.entries()) {
    dict[key] = value
  }

  return dict as UrlParams
}
